import React, { useEffect } from "react";

const events = [
  { id: 1, title: "Onboarding", duration: 60, color: "#059669" },
  { id: 2, title: "1:1 Review", duration: 30, color: "#3B82F6" },
  { id: 3, title: "Partnerships", duration: 60, color: "#FBBF24" },
  { id: 4, title: "Team Sync", duration: 45, color: "#A78BFA" },
  { id: 5, title: "Product Demo", duration: 30, color: "#EF4444" },
  { id: 6, title: "Customer Feedback", duration: 30, color: "#6366F1" },
  { id: 7, title: "Marketing Strategy", duration: 60, color: "#EC4899" },
  { id: 8, title: "Design Review", duration: 45, color: "#14B8A6" },
  { id: 9, title: "QA Testing", duration: 30, color: "#F97316" },
  { id: 10, title: "Roadmap Planning", duration: 60, color: "#4B5563" },
];

function Woztell() {
  // Hide Tidio chat via API and CSS override
  useEffect(() => {
    // Try hiding with the API
    if (window.tidioChatApi && typeof window.tidioChatApi.hide === "function") {
      window.tidioChatApi.hide();
    }
    // Append global CSS to ensure any Tidio elements are hidden
    const style = document.createElement("style");
    style.innerHTML = `
      #tidio-chat, .tidio-chat, iframe[src*="tidio"] {
        display: none !important;
      }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  return (
    <div className="tw-min-h-screen tw-flex tw-items-center tw-justify-center tw-bg-gray-50">
      <div className="tw-w-full tw-max-w-4xl tw-p-4 tw-space-y-4">
        {events.map((event) => (
          <div
            key={event.id}
            className="tw-flex tw-items-center tw-bg-white tw-border tw-border-gray-200 tw-rounded-lg tw-shadow-sm hover:tw-bg-gray-100 tw-transition-colors tw-duration-200"
          >
            {/* Colored bar on the left */}
            <div
              className="tw-w-2 tw-self-stretch tw-rounded-l-lg"
              style={{ backgroundColor: event.color }}
            />

            {/* Event details */}
            <div className="tw-flex-1 tw-p-4">
              <h5 className="tw-text-xl tw-font-bold tw-text-gray-900">
                {event.title}
              </h5>
              <p className="tw-text-gray-700">
                {event.duration} {event.duration === 60 ? "min / 1h" : "min"}
              </p>
            </div>

            {/* Action button */}
            <button
              type="button"
              className="tw-mr-4 tw-py-2 tw-px-4 tw-bg-blue-600 tw-text-white tw-font-semibold tw-rounded-lg hover:tw-bg-blue-700 tw-transition-colors tw-duration-200"
            >
              Choose
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Woztell;
